import React from 'react'

const Separator = (): JSX.Element => <div className="separator" />

export default Separator